import { modulesConfig } from '@/containers/SubscriptionFormPageNew/config'

type BreakManagementAuthData = {
  country?: string
  commonData?: { breakManagementEnabled?: boolean }
}

export const isBreakManagementAvailable = ({ country = '', commonData }: BreakManagementAuthData): boolean =>
  // @ts-ignore
  Boolean(modulesConfig[country]?.menu?.breaks) && commonData?.breakManagementEnabled === true
